export default function SeoFooter() {
  return (
    <footer className="bg-white py-14 text-scr-ink">
      <div className="mx-auto w-full max-w-6xl px-6">
        {/* About */}
        <section aria-labelledby="seo-about" className="mb-12">
          <h2 id="seo-about">Play Pictionary Online — A Free Drawing &amp; Guessing Party Game</h2>
          <p>
            Pictionary is a free, real-time multiplayer drawing
            and guessing game you can play right in your browser with friends — no downloads,
            no accounts, just a 6-letter room code. Every round, one player picks up the
            virtual pencil and sketches a secret word while everyone else races to type the
            answer in the chat. Up to 8 players per room makes it perfect for game nights,
            video calls, and classrooms.
          </p>
          <p>
            Think quick and draw quick. The faster a guess lands, the more points that player
            scores, and the artist earns a bonus for every correct guess. After everyone has
            taken their turn at drawing, the highest score wins. It is like classic Pictionary
            played online, but faster and free forever.
          </p>
        </section>

        {/* How to play */}
        <section aria-labelledby="seo-howto" className="mb-12">
          <h2 id="seo-howto">How to Play Pictionary</h2>
          <ol>
            <li>Open etoo.in/pictionary and type a nickname.</li>
            <li>
              Create a game room to get a 6-letter room code, and share it with your friends.
              They join with the same code from any device.
            </li>
            <li>
              Each round, one player draws a secret word on the shared canvas. Don&apos;t draw
              letters — draw the idea.
            </li>
            <li>
              Everyone else guesses the word in the chat. Correct guesses earn points based on
              how fast you got it, and each guesser earns the artist a bonus.
            </li>
            <li>When all players have drawn, the player with the most points wins.</li>
          </ol>
        </section>

        {/* Scoring */}
        <section aria-labelledby="seo-scoring" className="mb-12">
          <h2 id="seo-scoring">Pictionary Rules and Scoring</h2>
          <ul>
            <li>Turn time and rounds per player are chosen by the host before the game starts.</li>
            <li>Guesses that land early score more — the first fast guess is worth the most.</li>
            <li>
              If the drawing is too tricky, the word&apos;s letters reveal one at a time as a
              hint, so rounds always resolve.
            </li>
            <li>
              Pictionary runs live over a real-time connection, so every stroke and message
              appears instantly on laptops, phones, and tablets.
            </li>
          </ul>
        </section>

        {/* FAQ */}
        <section aria-labelledby="seo-faq">
          <h2 id="seo-faq">Frequently Asked Questions</h2>
          <div className="space-y-6">
            <article>
              <h3>Is Pictionary free to play?</h3>
              <p>
                Yes. Pictionary is 100% free — no downloads, no sign-ups, and no accounts.
                Create a room, share the code, and play with up to 8 friends.
              </p>
            </article>
            <article>
              <h3>How do I play Pictionary online with friends?</h3>
              <p>
                Open the Pictionary game page and create a room. A 6-letter room code appears —
                share it with your friends, they join from their own devices, and someone
                sketches while everyone else guesses. It is a Pictionary-style draw and guess
                game playable from any browser.
              </p>
            </article>
            <article>
              <h3>How many players can join a Pictionary room?</h3>
              <p>
                Each room supports 2 to 8 players. The host can also set the turn time
                (60–120 seconds) and the number of drawing rounds per player (1–4).
              </p>
            </article>
            <article>
              <h3>How does scoring work in Pictionary?</h3>
              <p>
                Guess the word correctly and you earn points — the faster the guess, the more
                points (with a minimum of 5 per correct answer). The player who drew the word
                earns a bonus for every guesser. The highest total when all rounds end wins.
              </p>
            </article>
            <article>
              <h3>Can I play Pictionary on my phone?</h3>
              <p>
                Yes. Pictionary works on any device with a modern browser, including iPhones,
                iPads, Android phones, and tablets — drawing works with touch, a mouse, or a
                trackpad.
              </p>
            </article>
          </div>
        </section>

        {/* Internal links */}
        <nav className="mt-14 border-t border-scr-border/70 pt-8" aria-label="More about Pictionary">
          <p className="text-sm font-bold text-scr-ink/70">
            Learn more about Pictionary
          </p>
          <ul className="mt-3 flex flex-wrap gap-x-6 gap-y-2 text-sm">
            <li>
              <a className="text-scr-accent-dark hover:underline" href="/ticket-to-train/">
                Ticket to Train online
              </a>
            </li>
            <li>
              <a className="text-scr-accent-dark hover:underline" href="/splendour/">
                Splendour online
              </a>
            </li>
            <li>
              <a className="text-scr-accent-dark hover:underline" href="/flappy-bird/">
                Flappy Bird online
              </a>
            </li>
            <li>
              <a className="text-scr-accent-dark hover:underline" href="/brick-breaker/">
                Neon Breaker online
              </a>
            </li>
            <li>
              <a className="text-scr-accent-dark hover:underline" href="/blog/">
                The etoo blog
              </a>
            </li>
            <li>
              <a className="text-scr-accent-dark hover:underline" href="/blog/how-to-play-scribble-online">
                How to play Pictionary — full guide
              </a>
            </li>
            <li>
              <a className="text-scr-accent-dark hover:underline" href="/blog/scribble-drawing-strategy">
                Pictionary drawing strategy
              </a>
            </li>
            <li>
              <a className="text-scr-accent-dark hover:underline" href="/blog/scribble-scoring-hints-explained">
                Pictionary scoring and hints explained
              </a>
            </li>
          </ul>
        </nav>

        <p className="mt-10 text-center text-xs text-scr-ink/40">
          © {new Date().getFullYear()} etoo games · Pictionary — free online drawing and guessing party game
        </p>
      </div>
    </footer>
  );
}